export const SET_BOOKINGS = 'SET_BOOKINGS';